import { PlatformBreakdown } from "../../../api/payments/overview/overview.responses";
import { Badge } from "../../ui/Badge";
import { Card, CardContent, CardHeader, CardTitle } from "../../ui/Card";

const SOURCE_LABELS: Record<string, string> = {
  IOS: "iOS",
  ANDROID: "Android",
  WEB: "Web",
  PROMOTIONAL: "Promotional",
  UNKNOWN: "Unknown",
};

interface PlatformBreakdownCardProps {
  byPlatform: PlatformBreakdown[];
}

export function PlatformBreakdownCard({ byPlatform }: PlatformBreakdownCardProps) {
  return (
    <Card>
      <CardHeader>
        <CardTitle className="text-base">Purchases by Platform</CardTitle>
      </CardHeader>
      <CardContent>
        <div className="flex flex-wrap gap-3">
          {byPlatform
            .filter((p) => p.count > 0)
            .map((p) => (
              <div
                key={p.source}
                className="flex items-center gap-2 rounded-md border px-3 py-2"
              >
                <span className="text-sm font-medium">
                  {SOURCE_LABELS[p.source] ?? p.source}
                </span>
                <Badge variant="secondary">{p.count}</Badge>
              </div>
            ))}
          {byPlatform.every((p) => p.count === 0) && (
            <p className="text-sm text-muted-foreground">No purchases yet.</p>
          )}
        </div>
      </CardContent>
    </Card>
  );
}
